import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';

import './style.scss';

const ProcessPopup = ({ title, content, icon }) => {
  const t = useTranslation();

  return (
    <div className="popup-content popup-small popup-process">
      <p className="popup-title">{t(title)}</p>
      <div className="popup-main-content">
        {icon && <i className={`global-icon icon-${icon} popup-main-icon`} />}
        {content && <p className="process-popup-content">{t(content)}</p>}
      </div>
    </div>
  );
};

export default ProcessPopup;

ProcessPopup.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  icon: PropTypes.string,
};
